import React from "react";
var DpIdMob = function (props) {
    var _a;
    return (React.createElement(React.Fragment, null, (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        return (React.createElement("div", { className: "brd-bottom  pt-3 mobile-gc-table pb-3" },
            React.createElement("div", { className: "main-id-row" },
                React.createElement("div", { className: "main-id-col" }, "DP Name"),
                React.createElement("div", { className: "main-id-col-data" }, item.dpName)),
            React.createElement("div", { className: "main-id-row" },
                React.createElement("div", { className: "main-id-col" }, "DP ID"),
                React.createElement("div", { className: "main-id-col-data" }, item.dpId)),
            React.createElement("div", { className: "main-id-row" },
                React.createElement("div", { className: "main-id-col" }, "DP Account"),
                React.createElement("div", { className: "main-id-col-data" }, item.dpAcc)),
            React.createElement("div", { className: "main-id-row" },
                React.createElement("div", { className: "main-id-col" }, "Depository"),
                React.createElement("div", { className: "main-id-col-data" }, item.depositoryType))));
    })));
};
export default DpIdMob;
